"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerAddress = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const address_entity_1 = require("./address.entity");
const broker_entity_1 = require("./broker.entity");
let BrokerAddress = class BrokerAddress {
};
exports.BrokerAddress = BrokerAddress;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], BrokerAddress.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "broker_id" }),
    tslib_1.__metadata("design:type", Number)
], BrokerAddress.prototype, "brokerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Number)
], BrokerAddress.prototype, "addressId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => broker_entity_1.Broker, (broker) => broker.brokerAddresses, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "broker_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokerAddress.prototype, "broker", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, (address) => address.brokerAddresses, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "address_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokerAddress.prototype, "address", void 0);
exports.BrokerAddress = BrokerAddress = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "broker_address" })
], BrokerAddress);
